export default __webpack_public_path__ + "static/media/ebrima-bold.738ab64f.ttf";